import { faEnvelope, faLocation, faPhone, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
import type { Ind } from '@api/Entities/Ind/Ind';
import { Link } from 'react-router-dom';
import { UserFlagButton } from '../User/UserFlagButton';
import { IndFlagButton } from './IndFlagButton';

export type IndMiniCardProps = {
  individual: Ind;
  show?: Array<'flags'>;
};

export const IndMiniCard = ({ individual, show = [] }: IndMiniCardProps) => {
  const address = individual.getDefaultAddress();
  const phoneNumber = individual.getDefaultPhone();
  const email = individual.getDefaultEmail();
  const flags = individual.getFlags().getItems();

  const cityState = address
    ? [address.getIndAddressCity(), address.getIndAddressState()].filter(Boolean).join(', ')
    : '';

  return (
    <Card
      role="button"
      className="border mb-2 text-decoration-none mini-card"
      as={Link}
      to={`/agent/profile/${individual.getIndId()}`}
    >
      <Card.Body className="px-3">
        {show.includes('flags') && flags && (
          <div className="float-end">
            {flags.map((flag) => {
              return (
                <IndFlagButton
                  selected={true}
                  className="ms-1"
                  key={flag.getIndFlagId()}
                  flag={flag}
                />
              );
            })}
          </div>
        )}
        <h6 className="fw-bold mt-0 mb-0">
          <FontAwesomeIcon icon={faUserCircle} className="me-1" /> {individual.getIndName()}
        </h6>
        {cityState && (
          <p className="ms-3 mb-0 small">
            <FontAwesomeIcon icon={faLocation} className="me-1" />
            {cityState}
          </p>
        )}
        {phoneNumber && (
          <p className="ms-3 mb-0 small">
            <FontAwesomeIcon icon={faPhone} className="me-1" />
            {phoneNumber.getIndPhoneNumber()}
          </p>
        )}
        {email && (
          <p className="ms-3 mb-0 small">
            <FontAwesomeIcon icon={faEnvelope} className="me-1" />
            {email.getIndEmailAddress()}
          </p>
        )}
      </Card.Body>
    </Card>
  );
};
